import Styles from '../index.mobile.module.scss';
import { Button, Form, Grid, Input, TextArea, Selector } from 'antd-mobile';
import { Radio } from 'antd';
import Agreement from '../../commonComponents/agreement';
import { useState } from 'react';
import { phoneNumberValidator } from '../../../utils/common';
import Success from '../../commonComponents/success';

interface SuggestTypeItem {
  itemValue: string;
  itemName: string;
}

interface IProps {
  suggestions: {
    titleText: string;
    titleDesc: string;
  };
  suggestTypeMap: SuggestTypeItem[];
  onCreate: Function;
}

const MobileFeedback = ({ suggestions, suggestTypeMap, onCreate }: IProps) => {
  const [agree, setAgree] = useState<boolean>(false);
  const [success, setSuccess] = useState<boolean>(false);
  const handleSubmit = async (values) => {
    if (values) {
      values.suggestType = values.suggestType[0];
      const res = await onCreate(values);
      if (res) {
        setSuccess(true);
      }
    }
  };

  return (
    <>
      {success ? (
        <Success text={'您的建议已收到，我们会尽快安排专家与您联系'} />
      ) : (
        <div className={Styles.formContainer}>
          <div className={Styles.formLabel}>{suggestions.titleText}</div>
          <div className={Styles.formDesc}>{suggestions.titleDesc}</div>
          <Form
            layout="vertical"
            footer={
              <Button
                className={Styles.submitBtn}
                block
                type="submit"
                color="primary"
                size="large"
                disabled={!agree}
              >
                提交
              </Button>
            }
            onFinish={handleSubmit}
            className={Styles.form}
          >
            <Form.Item
              className={Styles.formList}
              name="suggestType"
              label="建议类型"
              rules={[{ required: true, message: '请选择建议类型' }]}
            >
              <Selector
                options={suggestTypeMap.map((item) => {
                  return {
                    label: item.itemName,
                    value: item.itemValue,
                  };
                })}
                columns={3}
                className={Styles.radioBtn}
                showCheckMark={false}
              />
            </Form.Item>
            <Form.Item
              className={Styles.formList}
              name="title"
              label="标题"
              layout="horizontal"
              rules={[
                { required: true, message: '请输入标题', whitespace: true },
              ]}
            >
              <Input placeholder="请输入" />
            </Form.Item>
            <Form.Item
              className={Styles.formList}
              name="suggestContent"
              label="建议内容"
              rules={[
                { required: true, message: '请输入建议内容', whitespace: true },
              ]}
            >
              <TextArea
                className={Styles.textArea}
                rows={5}
                maxLength={200}
                placeholder="请详细填写您的建议内容，以便我们定位与改进"
              />
            </Form.Item>
            <Form.Item
              className={Styles.formList}
              name="phoneNum"
              label="联系方式"
              validateTrigger="onblur"
              layout="horizontal"
              rules={[{ validator: phoneNumberValidator() }]}
            >
              <Input
                placeholder="请输入手机号（非必填项）"
                type="number"
                pattern="[0-9]*"
              />
            </Form.Item>
            <Form.Item className={Styles.formAgreement}>
              <Agreement
                text="已阅读并同意StreamLake"
                onChange={(val) => {
                  setAgree(val);
                }}
              />
            </Form.Item>
          </Form>
        </div>
      )}
    </>
  );
};

export default MobileFeedback;
